var map = {
	"./bg_1.png": 366,
	"./bg_2.png": 4629,
	"./bg_3.png": 6616,
	"./bg_4.png": 2157,
	"./bg_5.png": 9700,
	"./bird.jpg": 4087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 847;